var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReviews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 58,
    viewBox: "0 0 54 58",
    width: 54,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.8363 29.4689c6.3679-6.5126 6.3679-17.0717 0-23.58441-6.368-6.512654-16.6924-6.512654-23.06035 0-6.36793 6.51271-6.36793 17.07181 0 23.58441 6.36795 6.5127 16.69235 6.5127 23.06035 0zm0 0 3.4163 3.494m0 0-.5598.5725c-.8701.8899-.8701 2.3326 0 3.2224l7.4191 7.6097c.8701.8898 2.2807.8898 3.1508 0l1.1196-1.1451c.8701-.8898.8701-2.3326 0-3.2224l-7.4191-7.6097c-.87-.8898-2.2807-.8898-3.1508 0z",
    stroke: "#4ee39d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.3414 14.1003c.3905-.3906.3905-1.0237 0-1.4143l-2.3097-2.3096c-.3905-.39054-1.0237-.39053-1.4142 0l-6.9645 6.9645c-.3905.3905-1.0237.3905-1.4142 0l-2.3097-2.3097c-.3905-.3905-1.0237-.3905-1.4142 0l-2.3097 2.3097c-.3905.3905-.3905 1.0237 0 1.4142l4.6194 4.6193c1.1715 1.1716 3.071 1.1716 4.2426 0z",
    stroke: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#4ee39d",
    height: 14.9057,
    opacity: 0.4,
    rx: 2,
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -15.018725 34.501391)",
    width: 6.25895,
    x: 34.1375,
    y: 35.3799
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReviews);
export default __webpack_public_path__ + "static/media/Icon-Reviews.16551610b08e1bda94aa7ac9d7c3a0e6.svg";
export { ForwardRef as ReactComponent };